import {
    ACT_ELECTRON_BUS_OPEN_WINDOW,
    ACT_ELECTRON_BUS_UPDATE_WINDOW,
    ACT_ELECTRON_BUS_CLOSE_WINDOW,
    ACT_ELECTRON_BUS_SET_WINDOW_SIZE,
    ACT_ELECTRON_BUS_SET_EVENTS_COUNT,
    ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP,
    ACT_ELECTRON_BUS_SHOW_MAIN_WINDOW,
} from '../actionsTypes'

import { getTrayImageWithCounter,  getTaskBadgeCounter } from '../../common/ImageWorker'

import { IPC_EVENTS } from '../../../electron/constants'

import ipc from '../../../electron/ipc/ipc'

const checkWindowPayload = (payload) => {
    if (!payload) throw new Error('empty payload')
    if (!payload.windowId) throw new Error('no windowId prop')
    const windowId = payload.windowId
    if (typeof windowId === 'object') {
        if (!windowId.name) throw new Error('name not set')
        if (!windowId.payload) throw new Error('payload not set')
    } else if (typeof windowId !== 'string') {
        throw new Error('windowId unsupported type')
    }
}

const state = {

}

const getters = {

}

const actions = {
    [ACT_ELECTRON_BUS_OPEN_WINDOW]: (obj, payload) => {
        checkWindowPayload(payload)
        ipc.send(IPC_EVENTS.OPEN_WINDOW, payload)
    },
    [ACT_ELECTRON_BUS_UPDATE_WINDOW]: (obj, payload) => {
        checkWindowPayload(payload)
        ipc.send(IPC_EVENTS.UPDATE_WINDOW, payload)
    },
    [ACT_ELECTRON_BUS_CLOSE_WINDOW]: (obj, payload) => {
        checkWindowPayload(payload)
        ipc.send(IPC_EVENTS.CLOSE_WINDOW, payload)
    },
    [ACT_ELECTRON_BUS_SET_WINDOW_SIZE]: (obj, payload) => {
        checkWindowPayload(payload)
        ipc.send(IPC_EVENTS.SET_WINDOW_SIZE, payload)
    },
    [ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP]: (obj, payload) => {
        checkWindowPayload(payload)
        ipc.send(IPC_EVENTS.TOGGLE_WINDOW_ON_TOP, payload)
    },
    [ACT_ELECTRON_BUS_SHOW_MAIN_WINDOW]: () => {
        ipc.send(IPC_EVENTS.SHOW_MAIN_WINDOW)
    },
    [ACT_ELECTRON_BUS_SET_EVENTS_COUNT]: async (obj, count) => {
        let taskBadge
        let trayImage = await getTrayImageWithCounter(count)
        if (count) taskBadge = await getTaskBadgeCounter(count)
        ipc.send(IPC_EVENTS.SET_EVENTS_COUNT, {count, trayImage, taskBadge})
    },
}
/*let i = 0
setInterval(() => {
    i++
    app.store.dispatch(`${ELECTRON_BUS}/${ACT_ELECTRON_BUS_SET_EVENTS_COUNT}`, i % 2 ? 0 : i)
}, 500)*/

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
